import { GETNEW, POSTNEW, } from '@/request/http'
//获取待办列表
export const getToDoInfo = p => POSTNEW('/backlog/backlog-info/page/TEA', p)

//获取待办类型
export const getToDoType = p => GETNEW('/backlog/backlog-type/list', p, 4)

//获取待办类型
export const getToDoCount = p => GETNEW('/backlog/backlog-info/count/TEA', p, 4)

//首页统计接口（角标）
export const getCornerMarker = p => GETNEW('/backlog/backlog-info/count/TEA', p, 4)


// WEBPACK FOOTER //
// ./src/api/modules/todo.js